<template
  xmlns:height="http://www.w3.org/1999/xhtml"
  xmlns:width="http://www.w3.org/1999/xhtml"
  xmlns:float="http://www.w3.org/1999/xhtml"
  xmlns:object-fit="http://www.w3.org/1999/xhtml"
>
<div class="listItemWithEditButton">
    <div class="edit">
          <button
            class="editButton"
            @click="startEdit"
          >
          <img class="editButtonImage" src="@/assets/editbutton.png"/>
          </button>
          
    </div>
    <div class="delet">
          <button
            class="editButton"
            @click="deletItem"
          >
          <img class="editButtonImage" src="@/assets/deletIcon.png"/>
          </button>
    </div>
  <div class="listItem">
    <div class="imageBorder">
        <img
          :src="`${imageURL}`"
           class="productImage"
        >
    </div>
    <div class="brand">
      {{ brand }} 
    </div>
    <div class="designation">
      {{ designation }}
    </div>
  </div>
</div>
</template>

<script>
    export default {
        name: "ArticleListItemWithPreview",
        props: ['brand', 'designation', 'ean', 'imageURL'],

        methods: {
            startEdit() {
                this.$emit('edit')
            },
            deletItem(){
                this.$emit('delet')
            }
        }

    }
</script>

<style >
    .listItemWithEditButton {
      display: block;
      float: left;
      position: relative;
      padding: 20px;
      width: 260px;
      height: 360px;
    }
    .listItem {
      overflow: hidden;
      width: 190px;
      height: 320px;
      background-color: rgb(247, 247, 247);
      border-radius: 30px;
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 4px 20px 0 rgba(104, 104, 104, 0.19);
      background-color: white;
    }
    
    .imageBorder {
      z-index:0;
      background-color: white;
      height: 220px;
      border-radius: 30px;
      box-shadow: 0 1px 3px 0 rgba(82, 81, 81, 0.2), 0 4px 20px 0 rgba(104, 104, 104, 0.19);
    }

    .productImage {
      width: 180px;
      height: 180px;
      padding-left: 10px;
      object-fit: scale-down;
      margin-top: 20px;
    }

    .brand {
      text-align: left;
      font-size: 16px;
      padding-left: 20px;
      padding-right: 20px;
      padding-top: 15px;
      padding-bottom: 5px;
      font-family: 'Exo', sans-serif;
      font-weight: bold;
      color: black;
    }

    .designation{
      text-align: left;
      font-size: 13px;
      padding-left: 20px;
      padding-right: 20px;
      font-family: 'Exo', sans-serif;
    }
    .edit {
      z-index:1;
      position: absolute;
      right: 15px;
      top: 5px;
    }
    .editButton{
      border-width: 0px;
      border-radius: 50px;
      background-color: white;
      box-shadow: 0 1px 3px 0 rgba(82, 81, 81, 0.2), 0 4px 20px 0 rgba(104, 104, 104, 0.19);
    }

    .delet {
      z-index:1;
      position: absolute;
      right: 15px;
      top: 65px;
    }

    .deletButton{
      border-width: 0px;
      border-radius: 50px;
      background-color: white;
      box-shadow: 0 1px 3px 0 rgba(82, 81, 81, 0.2), 0 4px 20px 0 rgba(104, 104, 104, 0.19);
    }
    .editButtonImage
    {
      height: 50px;
      width: 50px;
      
    }
    
    
</style>